import React, { Component, Fragment } from 'react'
import { inject, observer } from 'mobx-react'
import { AutoComplete } from 'antd'

import Passenger from './Passenger'
import OrderTime from './OrderTime'
import OrderOptions from './OrderOptions'
import DestionationPoints from './DestionationPoints'

import './Order.scss'

const { Option } = AutoComplete

@observer
class Order extends Component {
  state = { 
    carClass: 2,
    inTheCity: false,
  }

  pointsOrInCity = (status) => {
    this.setState({
      inTheCity: status
    })
  }

  chgCarclassName = id => {
    this.props.setCarClass(id)
  }

  onHouseSearch = (searchField, i) => {
    const house = searchField ? searchField : false
    this.props.getHouse(house, i)
  }
  onHouseSelect= (value, option) => {
    this.props.setHouse(option.props.label, option.props.iter, option.props.label)
  }

  onStreetSearch = (searchText, i) => {
    if(searchText.length > 2){
      this.props.getStreets(this.props.clientPhone, searchText, i)
    }    
  }

  onStreetSelect = (value, option) => {
    this.props.setStreet(option.props.streetid, option.props.streettype === 1 ? true : false, option.props.iter, option.props.label)
  }

  createOrder = () => {
    let isError = false

    if(!this.props.distance || !this.props.price[this.props.carClass]){
      this.props.setErrorMsg('Для создания заказа необходимо построить маршрут!')
      isError = true
    }

    if(this.props.pointsCoords.length > 1 && this.props.pointsCoords[0].length === 2 && this.props.pointsCoords[1].length === 2){
      this.props.setErrorMsg('Не указан маршрут! Выберите начальную и конечную точку из выпадаюзего списка.')
      isError = true
    }
    

    if(!isError){
      this.props.createOrder()
    }
  }

  noRoute = () => {
    this.props.setErrorMsg('Для создания заказа необходимо построить маршрут!')
  }
  
  render() {
    let orderBtnOrPrice = <button className="btn-order" onClick={this.noRoute}>Заказать</button>
    if(this.props.price[this.props.carClass] && this.props.distance){
      orderBtnOrPrice = (
      <div className="order-call">
        <button className="btn-reset" onClick={this.props.clearOrderForm}></button>
        <div className="order-call__container">
          <div className="order-summary">
            <div className="order-total">
              <span>{this.props.price[this.props.carClass]}</span> грн
            </div>
            <div className="order-distance">
              <span>{this.props.distance}</span> км
            </div>
          </div>
          <button className="btn-order" onClick={this.createOrder} id="order-module-order-btn-success"> Заказать </button>
        </div>
      </div>)
    }

    // Список найденных улиц для стартовой улицы
    const dataSource = this.props.findedStreets[0].map( street => {
      const optionKey = `${street.namerus} ${street.id}`;
      return (<Option
        key={optionKey}
        streetid={street.id}
        label={street.namerus}
        streettype={street.streettype}
        geox={street.geox}
        geoy={street.geoy}
        iter={0}
        title={street.namerus}
      >
        {street.streettype === 0 ? street.namerus : street.namerus}
      </Option>)
    })
    // Список найденных домов для стартовой точки
    const houseDataSource = this.props.findedHouses[0].map( house => {
      const optionKey = `${house.id} ${house.geox}`;
      return (<Option
        key={optionKey}
        houseid={house.id}
        label={house.value}
        iter={0}
        geox={house.geox}
        geoy={house.geoy}
      >
        {house.value}
      </Option>)
    })

    const destinationFields = this.props.findedStreets.map( (fieldsRow, i) => {
      if(i < 1){
        return <Fragment key={i}></Fragment>
      } else {
        return <DestionationPoints key={i} clearBtn={i > 1} iter={i} />
      }      
    })

    return (<>
      <div className="choose-carclass">
        <ul className="categories">
          <li className={this.props.carClass === 4 ? "car-category all active" : "car-category all" } onClick={() => this.chgCarclassName(4)}>
            <div className="car-category__name">Все</div>
            <i className="car-category__icon icons all"></i>
          </li>
          <li className={this.props.carClass === 2 ? "car-category standard active" : "car-category standard" } onClick={() => this.chgCarclassName(2)}>
            <div className="car-category__name">Стандарт</div>
            <i className="car-category__icon icons standard"></i>
          </li>
          <li className={this.props.carClass === 1 ? "car-category business active" : "car-category business" } onClick={() => this.chgCarclassName(1)}>
            <div className="car-category__name">Бизнес</div>
            <i className="car-category__icon icons business"></i>
          </li>
          <li className={this.props.carClass === 5 ? "car-category premium active" : "car-category premium" } onClick={() => this.chgCarclassName(5)}>
            <div className="car-category__name">Премиум</div>
            <i className="car-category__icon icons premium"></i>
          </li>
        </ul>
        <p>Выберите категорию авто</p>
      </div>
      <div className="start-point order-section">
        <div>
          <h3 className="start-address__title"><i className="start-address__icon icons">п</i> Адрес подачи авто</h3>
        </div>
        <div className="row order-row">
          <div className="col">
            <AutoComplete
              dataSource={dataSource}
              onSelect={this.onStreetSelect}
              onSearch={text => this.onStreetSearch(text, 0)}
              onChange={text => this.props.onChangeStreet(text, 0)}
              className="form-control webcab-field"
              placeholder="Улица *"
              value={this.props.selectedStreet[0]}
            />
          </div>
          <div>
            
          </div>
        </div>
        <div className="row order-row">
            <div className="col-4">
              <AutoComplete
                dataSource={houseDataSource}
                onSelect={this.onHouseSelect}
                onSearch={text => this.onHouseSearch(text, 0)}
                onChange={text => this.props.onChangeHouse(text, 0)}
                className="form-control webcab-field"
                disabled={this.props.isPOI[0]}
                placeholder="Дом *"
                value={this.props.selectedHouse[0]}
              />
            </div>
            <div className="col-4">
              <input type="text" className="form-control webcab-field" name="frontdoor" value={this.props.frontdoor} onChange={this.props.chgFrontdoor} placeholder="Квартира" />
            </div>
            <div className="col-4">
              <input type="text" className="form-control webcab-field" name="flat" value={this.props.flat} onChange={this.props.chgFlat} placeholder="Подъезд" />
            </div>
          </div>
        <div className="row order-row">
          <div className="col">
            <textarea value={this.props.comment} onChange={this.props.chgComment} className="form-control webcab-field comment-field" placeholder="Ваши пожелания касательно поездки" />
          </div>
        </div>
        <Passenger />
        <OrderTime />
      </div>
      <div className="order-section service-section">
        <OrderOptions />
      </div>
      <div className="order-section order-form-end">
        <div className="row dest-heder">
          <div className="lm-dest"><h3  className={this.state.inTheCity ? "destination__title destination__title--active" : "destination__title" }  onClick={() => this.pointsOrInCity(false)}><i className="destination__icon icons">т</i>Адрес прибытия авто</h3></div>
          <div className={this.state.inTheCity ? "lm-dest in_the_city" : "lm-dest in_the_city in_the_city--active" } onClick={() => this.pointsOrInCity(true)}>По городу</div>
          
        </div>
        {this.state.inTheCity ? 
          <div className="row">
            <div className="col">
              <p className="in-city-msg">Тарификация будет происходить по счетчику</p>
            </div>
          </div> 
          :
          <>
            {destinationFields}
            <div className="row">
              <button className="btn-add" onClick={this.props.addDestinationRow}><i className="btn-add__icon"></i> Добавить адрес</button>
            </div>
          </>
        }
        <div className="row">
          {orderBtnOrPrice}
        </div>
      </div>
      </>
    )
  }
}

const withData = inject(stores => ({
  clientPhone: stores.LoginFromStore.clientPhone,
  frontdoor: stores.OrderStore.frontdoor,
  flat: stores.OrderStore.flat,
  comment: stores.OrderStore.comment,
  setCarClass: stores.OrderStore.setCarClass,
  getStreets: stores.OrderStore.getStreets,
  streetsId: stores.OrderStore.streetsId,
  findedStreets: stores.OrderStore.findedStreets,
  setStreet: stores.OrderStore.setStreet,
  isPOI: stores.OrderStore.isPOI,
  getHouse: stores.OrderStore.getHouse,
  findedHouses: stores.OrderStore.findedHouses,
  setHouse: stores.OrderStore.setHouse,
  houses: stores.OrderStore.houses,
  addDestinationRow: stores.OrderStore.addDestinationRow,
  getRouteAndPrice: stores.OrderStore.getRouteAndPrice,
  price: stores.OrderStore.price,
  distance: stores.OrderStore.distance,
  carClass: stores.OrderStore.carClass,
  clearOrderForm: stores.OrderStore.clearOrderForm,
  selectedStreet: stores.OrderStore.selectedStreet,
  selectedHouse: stores.OrderStore.selectedHouse,
  onChangeStreet: stores.OrderStore.onChangeStreet,
  onChangeHouse: stores.OrderStore.onChangeHouse,
  chgFrontdoor: stores.OrderStore.chgFrontdoor,
  chgFlat: stores.OrderStore.chgFlat,
  chgComment: stores.OrderStore.chgComment,
  createOrder: stores.OrderStore.createOrder,
  pointsCoords: stores.OrderStore.pointsCoords,
  setErrorMsg: stores.NotificationsStore.setErrorMsg,
}))

export default withData(Order);

